import styled from "styled-components";
import { StyledMenuItemProps } from "./types";
// import {lightColors, darkColors, baseColors }from "../../theme/colors"

export const StyledMenuItemContainer = styled.div<StyledMenuItemProps>`
  position: relative;

  ${({ $isActive, $variant, theme }) =>
    $isActive &&
    $variant === "subMenu" &&
    `
      &::after{
        content: "";
        position: absolute;
        bottom: 0;
        height: 4px;
        width: 100%;
        background-color: #000;
        border-radius: 2px 2px 0 0;
      }
    `};
`;

const StyledMenuItem = styled.a<StyledMenuItemProps>`
  position: relative;
  display: flex;
  align-items: center;

  color: ${({ theme, $isActive }) => ($isActive ? "black" : " #333333")};
  font-size: 16px;
  font-weight: ${({ $isActive }) => ($isActive ? "600" : "400")};

  /* ${({ theme }) =>
    `
    &::after {
      content: "";
      border-radius: 100%;
      background: black;
      height: 8px;
      width: 8px;
      margin-left: 12px;
    }
  `} */

  ${({ $variant }) =>
    $variant === "default"
      ? `
    padding: 0 16px;
    height: 48px;
  `
      : `
    padding: 4px 4px 0px 4px;
    height: 42px;
  `}

  &:hover {
    /* background: "blue";
    ${({ $variant }) => $variant === "default" && "border-radius: 16px;"}; */
    color: #ffce22;
  }
`;

export default StyledMenuItem;
